export default __webpack_public_path__ + "static/media/Image2x.b13c5703.png";